module.exports = __webpack_public_path__ + "img/fastBackward.a8f392db.svg";